module.exports = __webpack_public_path__ + "img/huawei-harmonyos.38d69b59.png";